import { render } from "./TodoCardShowLogin.vue?vue&type=template&id=35dab3dc"
import script from "./TodoCardShowLogin.vue?vue&type=script&lang=js"
export * from "./TodoCardShowLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__